import { render } from "./vorderlist.vue?vue&type=template&id=55bcb8d3&scoped=true"
import script from "./vorderlist.vue?vue&type=script&lang=js"
export * from "./vorderlist.vue?vue&type=script&lang=js"

import "./vorderlist.vue?vue&type=style&index=0&id=55bcb8d3&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境商户后台shop.jsyinba.com/jsmerchant/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55bcb8d3"]])

export default __exports__